import {BaseEventTrackerWrapper, ExtraData} from './BaseEventTrackerWrapper';

export class GoogleAnalyticsEventTracker extends BaseEventTrackerWrapper {
    private static tagNotDefined = (event: string, extraData?: ExtraData) => {
        console.log('gtag:', event, extraData ?? '');
    };

    public init(): void {
        if (!window.gtag) {
            console.warn('gtag is not defined, using console logger instead');
            this.tag = GoogleAnalyticsEventTracker.tagNotDefined;
        }
    }

    public tag(event: string, extraData?: ExtraData): void {
        window.gtag!('event', event, {
            ...extraData
        });
    }
}
